import getEditorData from '../../Common/getEditorData';
import saveEditorData from '../../Common/saveEditorData';
import router from '../../../router/routes';
import destroyEditorData from '../../Common/destroyEditorData';

const defaultState = () => {
    return {
        paletteId: undefined,
        name: undefined,
        deleteModal: false,
        order: 0,
        published: 0,
        route: undefined,
        color1: undefined,
        color2: undefined,
        color3: undefined,
        postData: [],
    };
};

const state = defaultState();

export default {
    namespaced: true,
    state,

    getters: {
        postData(state) {
            return {
                name: state.name,
                order: state.order,
                published: state.published,
                color_1: state.color1,
                color_2: state.color2,
                color_3: state.color3
            };
        },

        publishedText(state) {
            if (state.published) {
                return 'Published';
            } else {
                return 'Not Published';
            }
        },

        route(state) {
            if (state.paletteId) {
                return '/api/palette/edit/' + state.paletteId;
            } else {
                return '/api/palette/create';
            }
        }
    },

    mutations: {
        setPaletteId(state, value) {
            state.paletteId = value;
        },

        setName(state, value) {
            state.name = value;
        },

        setOrder(state, value) {
            state.order = value;
        },

        setPublished(state, value) {
            state.published = value;
        },

        toggleDeleteModal(state, value) {
            state.deleteModal = value;
        },

        setColor1(state, value) {
            state.color1 = value;
        },

        setColor2(state, value) {
            state.color2 = value;
        },

        setColor3(state, value) {
            state.color3 = value;
        },
    },

    actions: {
        resetState({state}) {
            return new Promise(resolve => {
                Object.assign(state, defaultState());
                resolve();
            });
        },

        getData({ commit, getters, state }) {
            commit('overlay/toggle', true, { root: true });
            commit('setPaletteId', router.currentRoute.params.id ? router.currentRoute.params.id : 0);

            if(state.paletteId) {
                getEditorData(getters.route).then((response) => {
                    const scheme = response.data.data.palette;
                    commit('setName', scheme.name);
                    commit('setOrder', scheme.order);
                    commit('setPublished', scheme.published);
                    commit('setColor1', scheme.color_1);
                    commit('setColor2', scheme.color_2);
                    commit('setColor3', scheme.color_3);
                    commit('overlay/toggle', false, { root: true });
                });
            } else {
                commit('setName', undefined);
                commit('setOrder', 0);
                commit('setPublished', 0);
                commit('setColor1', undefined);
                commit('setColor2', undefined);
                commit('setColor3', undefined);
                commit('overlay/toggle', false, { root: true });
            }
        },

        saveData({ getters, commit, dispatch }) {
            saveEditorData('palette', getters.route, getters.postData)
                .then((paletteId) => {
                    if (router.currentRoute.name === 'PaletteEdit') {
                        dispatch('sidebar/getSidebar', '', { root: true })
                            .then(() => {
                                commit('overlay/toggle', false, { root: true });
                            });
                    } else {
                        router.push('/palette/edit/' + paletteId);
                    }
                })
                .catch(() => {});
        },

        destroyData({ state }) {
            destroyEditorData('/api/palette/delete/' + state.paletteId)
                .then(() => {})
                .catch(() => {});
        },
    },
};
